export class WorkflowStageValidationModel {
  public IsValid: boolean;
  public IsValidPromotion: number;
  public Comment: string;
  public IsModified: boolean = false;
}
